export const SCORE_THRESHOLDS = {
  HIGH: 70,
  NOTABLE: 40,
  LOW: 15,
} as const

export type ScoreBand = 'high' | 'notable' | 'low' | 'none'

export function scoreBand(score: number | null | undefined): ScoreBand {
  if (score == null) return 'none'
  if (score >= SCORE_THRESHOLDS.HIGH) return 'high'
  if (score >= SCORE_THRESHOLDS.NOTABLE) return 'notable'
  if (score >= SCORE_THRESHOLDS.LOW) return 'low'
  return 'none'
}

export interface ScoreBandClasses {
  text: string
  bg: string
  label: string
}

export function scoreBandToken(score: number | null | undefined): ScoreBandClasses {
  const band = scoreBand(score)
  if (band === 'high')
    return {
      text: 'text-[var(--destructive)]',
      bg: 'bg-[var(--destructive)]/10',
      label: 'high',
    }
  if (band === 'notable')
    return {
      text: 'text-[var(--chart-4)]',
      bg: 'bg-[var(--chart-4)]/15',
      label: 'notable',
    }
  if (band === 'low')
    return {
      text: 'text-[var(--chart-1)]',
      bg: 'bg-[var(--chart-1)]/15',
      label: 'low',
    }
  return {
    text: 'text-[var(--muted-foreground)]',
    bg: 'bg-[var(--muted)]',
    label: 'none',
  }
}

export function scoreBandCssVar(band: ScoreBand): string {
  if (band === 'high') return 'var(--destructive)'
  if (band === 'notable') return 'var(--chart-4)'
  if (band === 'low') return 'var(--chart-1)'
  return 'var(--muted-foreground)'
}
